import React, { useContext } from 'react';
import FlexWrapper from '../../common/flex';
import NavLockIcon from './nav_lock_icon';
import UIContainer from '../../ui/container';
import { getMobileNavbarHeightPx } from '../../../utils/navbar_size';
import L from '../../common/localized';
import styled from 'styled-components';
import { useZendesk } from '../../../contexts/zendesk';
import I18nContext from '../../../contexts/i18n';
import { convertToImageKitUrl } from '@lemonadefashion/imagekit';
import SeoLink from '../../common/seo_link';

const SecureCheckoutNav = (props) => {
  const i18nSettings = useContext(I18nContext);
  const rtl = i18nSettings.isLocaleRTL();
  const height = getMobileNavbarHeightPx();
  const { openMessenger } = useZendesk();
  const logoSrc = convertToImageKitUrl('/branding/Pipp-web-logo.png', {});
  const checkoutNavLogoSrc = convertToImageKitUrl('/branding/purple-pipp-logo.png', {});
  return (
    props.desktop
      ? <AddedUIContainer dir={rtl ? 'rtl' : 'ltr'}>
          <UIContainer>
            <FlexWrapper justifyContent='space-between'>
              <FlexWrapper flex={1} justifyContent='flex-start'>
                <L text='Need Help?' />
                <ChatWithUsText onClick={openMessenger}>
                  <L text='Chat with us now' />
                </ChatWithUsText>
              </FlexWrapper>
              <FlexWrapper flex={1} justifyContent='center'>
                <SeoLink to='/'>
                  <SecureCheckoutDesktopLogo alt='PIPP checkout logo' src={checkoutNavLogoSrc} />
                </SeoLink>
              </FlexWrapper>
              <FlexWrapper flex={1} justifyContent='flex-end'>
                <NavLockIcon lockIconSize={22} />
                <SecureCheckoutText>
                  <L text='Secure Checkout' />
                </SecureCheckoutText>
              </FlexWrapper>
            </FlexWrapper>
          </UIContainer>
        </AddedUIContainer>
      : <AddedUIContainer dir={rtl ? 'rtl' : 'ltr'}>
          <UIContainer>
            <FlexWrapper justifyContent='space-between'>
              <div style={{
                height: height,
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                marginLeft: '12px'
              }}>
                <SecureCheckoutLogo alt='PIPP logo' src={logoSrc} />
              </div>
              <div style={{
                height: height,
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginRight: '12px'
              }}>
                <NavLockIcon lockIconSize={16} />
                <SecureCheckoutText>
                  <L text='Secure Checkout' />
                </SecureCheckoutText>
              </div>
            </FlexWrapper>
          </UIContainer>
        </AddedUIContainer>
  );
};

const ChatWithUsText = styled.a`
  -webkit-margin-start: 8px;
  margin-inline-start: 8px;
  text-decoration: underline;
  cursor: pointer;
  color: #131313;
  user-select: none;
  &:hover, &:focus {
    color: #7f7f7f;
    text-decoration: underline;
  }
  &:active {
    color: #aaa;
    text-decoration: underline;
  }
`;

const SecureCheckoutText = styled.p`
  font-size: 12px;
  @media only screen and (min-width: 375px) {
    font-size: 14px;
  }
  @media only screen and (min-width: 768px) {
    font-size: 16px;
  }
`;

const AddedUIContainer = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  border-bottom: 1px solid #ddd;
`;

const SecureCheckoutLogo = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
`;

const SecureCheckoutDesktopLogo = styled.img`
  height: 50px;
  width: auto;
  object-fit: contain;
`;

export default SecureCheckoutNav;
